import { Component, OnInit } from '@angular/core';
import { CapitalsService } from './../../services/capitals/capitals.service';
import { DepartamentService } from './../../services/departaments/departament.service';
import { SeoService } from './../../services/seo.service';

declare var Jquery: any;
declare var $: any;

@Component({
  selector: 'app-capitals',
  templateUrl: './capitals.component.html',
  styleUrls: ['./capitals.component.scss']
})
export class CapitalsComponent implements OnInit {

  chapters:any;
  years: any;
  yearActive:any = false;
  departaments:any;
  departamentActive:any = null;
  indicator: any = false;


  indicatorsCharts = {
    labels:[],
    data:[],
    legend:false,
    type: 'horizontalBar',
    pieChartOptions: {
      'backgroundColor': [
        "#F28321",
        "#006738",
        "#ED1651",
        "#B94E24",
        "#682062",
        "#ECCD1A",
        "#C1932B",
        "#AC2950",
        "#34495e"
       ]
    }

  };


  constructor(
    private departamentService: DepartamentService,
    private seoService:SeoService,
    private capitalsService : CapitalsService
  ) {
    this.seoService.setTagsPage({
      title:'Cptur | Proyectos',
      type:'website',
      description:'Proyectos',
      image:'/assets/images/logo.png'
    });
  }

  ngOnInit() {
    this.drawMap();
    this.getYears();
  }


  getYears(){
    this.capitalsService.getYears().subscribe(years => {
      this.years = years;
      this.yearActive = this.years[0];

      this.getDepartaments();
    })
  }

  setYear(year){
    this.yearActive = year;
    this.getIndicator();
  }

  getDepartaments(){
    this.departamentService.getDepartaments().subscribe(departaments => {
      this.departaments = departaments;
      this.departamentActive = this.departaments[Math.floor(Math.random()* this.departaments.length)];

      this.getIndicator(this.departamentActive.code,this.yearActive.year)

    })
  }

  getIndicator(depId = this.departamentActive.code,year = this.yearActive.year){

    this.capitalsService.getIndicator(depId,year).subscribe(indicator => {
      
      if (indicator == null) {
        this.indicator = false;
        return;
      }
      
      this.indicator = indicator;
      
      let labels = [];
      let data = [];
      this.indicator.ictrcReportsList.forEach(report => {
        labels.push(report.criterio);
        data.push(report.score)
      })
    
      this.indicatorsCharts.labels = labels;
      this.indicatorsCharts.data = data;
    
    })
  }

  viewDetails(){

  }
 

  public getDepartamentName(data: string): string {
    switch (data) {
      case 'BOGOTÁ - DISTRITO CAPITAL':
        // return 'Bogotá';
        return 'Bogotá, D.C.';
      case "CHOCÓ":
        return "Chocó";
      case "TOLIMA":
        return "Tolima";
      case "BOLÍVAR":
        return "Bolívar";
      case "SAN ANDRÉS Y PROVIDENCIA":
        return "Archipiélago de San Andrés";
      default:
        return data;
    }
  }


  private drawMap(): void {
    const _self = this;

    $('#map-colombia').CSSMap({
      'size': 750,
      'mapStyle': 'custom',
      'cities': true,
      'tooltips': false,
      'responsive': 'auto',
      'tapOnce': true,
      'loadingText':'Cargando...',
      'pins': {
        'enable': true,
        'pinsId': '#demo-markers',
        'mapSize': 750,
        'markerPosition': 'middle',
        'tooltipPosition': 'top',
        'tooltipOnClick': false,
        'clickableRegions': true
      },
      activateOnLoad: [
        'co5'
      ],
      onClick: function (e)
      {


        const rLink = e.children('A').eq(0).attr('href'),
          rText = e.children('A').eq(0).text(),
          rClass = e.attr('class').split(' ')[0];
        const filter = rText.trim().toUpperCase();
        let changed = false;
        
        
        let departament= _self.getDepartamentName(filter);
        
        let response = _self.departaments.find(dept => {
          return departament.trim().toUpperCase() === dept.name.trim().toUpperCase();
        });

        if (response != undefined) {

          _self.departamentActive = response;
          _self.getIndicator(_self.departamentActive.code)
        }else{
          // _self.getIndicator(15);
        }

      }
    });
  }


}
